<script setup lang="ts">
import data from './mocks'
import { EntityServiceHomePageCard } from '~/components/entity/service/home-page'
import type { IService } from '~/components/entity/service/home-page'

const services: IService[] = data
</script>

<template>
  <div class="flex flex-col gap-3.5">
    <div class="grid grid-cols-2 gap-5 md:grid-cols-4 lg:grid-cols-6">
      <EntityServiceHomePageCard
        v-for="service in services"
        :key="service.url"
        :heading="$t(service.heading)"
        :description="$t(service.description)"
        :image="service.image"
        :url="service.url"
        :badge="service.badge ? $t(service.badge) : undefined"
        :icon="service.icon"
      />
    </div>
  </div>
</template>
